import { makeStyles } from "@material-ui/core";

export default makeStyles(theme => {
  const {type} = theme.palette;
  const appbar = theme.palette.appbar[type];
  const fontColor = theme.palette.getContrastText(appbar);
  let button = {
    color: fontColor,
    borderColor: fontColor,
    marginRight: theme.spacing(1),
    marginLeft: theme.spacing(1),
  };
  return {
    MenuList: {
      display: "flex",
      flexFlow: "row nowrap",
      justifyContent: "flex-end",
      alignItems: "center",
      marginRight: "15px",
      height: "46px"
    },
    button,
    buttonLabel: {
      alignSelf: "center",
      alignItems: "center",
      verticalAlign: "middle"
    },
    login: {
      ...button,
      color: theme.palette.getContrastText(theme.palette.secondary.dark),
      border: "none"
    },
    signup: {
      ...button,
      color: theme.palette.getContrastText(theme.palette.secondary.dark),
      border: "none"
    },
    icon: {
      // marginRight: theme.spacing(1)
    }
  };
});
